/// <reference path="../../_references.js" />

if (isNullOrUndefined(sumo)) {
    throw ('GoogleMapControl.js requies the sumo namespace defined in SumoClass.js');
}

if (isNullOrUndefined(sumo.maps)) {
    sumo.maps = {};
}

sumo.maps.Locate = function (aId, aParentId, aMap, aOptions) {
    "use strict";
    var mThis = this,
        mId = aId,
        mParentId = aParentId,
        mMap = aMap.getMap(),
        //mService = new google.maps.places.PlacesService(mMap),
        //mOptions = aOptions,
        mHtml = null,
        //mSearchButton = null,
        //mClearButton = null,
        mTextBox = null;

    sumo.maps.Locate.prototype.baseClass.call(this);

    function onSearch_Complete(aResults, aStatus) {
        var lPlaceList = [],
            lPlace,
            i;
        if (aStatus === "OK") {
            for (i = 0; i < aResults.length; i++) {
                lPlace = aResults[i];
                lPlaceList.push(lPlace);
            }
        } else {
            mActivityNotification.addNotification(localizeWrapper('cDefaultNoResultsFound'));
        }
        mThis.trigger('complete', lPlaceList);
    }

    function onSearch() {
        var lRequest,
            lValue = mTextBox.val(),
            lMapCenter = mMap.getCenter(),
            lLocation = new google.maps.LatLng(lMapCenter.lat(), lMapCenter.lng());

        if (lValue !== '') {
            lRequest = {
                location: lLocation,
                radius: '300',
                query: lValue
            };
            textSearch(lRequest)
            //mService.textSearch(lRequest, onSearch_Complete);
        }
    }

    this.Search = function (aValue) {
        var lRequest,
            lValue = aValue,
            lMapCenter = mMap.getCenter(),
            lLocation = new google.maps.LatLng(lMapCenter.lat(), lMapCenter.lng());

        if (lValue !== '') {
            lRequest = {
                location: lLocation,
                radius: '300',
                query: lValue
            };
           // mService.textSearch(lRequest, onSearch_Complete);
            textSearch(lRequest)
        }
    }

    function onClear() {
        mTextBox.val('');
        mThis.trigger('complete', []);        
    }

    //this.Search = function()

    function initialize() {
        var lHtml = [],
            lSearchId = mId + 'MapLocateButton',
            lClearId = mId + 'MapClearButton',
            lTextId = mId + 'MapLocateText';
        lHtml.push('<div class="Clickable IconButton LocateClearButton FloatRight" id="');
        lHtml.push(lClearId);
        lHtml.push('"></div>');
        lHtml.push('<div class="Clickable IconButton LocateButton FloatRight" id="');
        lHtml.push(lSearchId);
        lHtml.push('"></div>');
        lHtml.push('<input type="text" id="');
        lHtml.push(lTextId);
        lHtml.push('" />');

        mHtml = lHtml.join('');
        $('#' + mParentId).html(mHtml);
        $('#' + lSearchId).click(onSearch);
        $('#' + lClearId).click(onClear);
        mTextBox = $('#' + lTextId);

        //keyup events in text box
        $('#' + lTextId).keyup(textbox_OnEnter);
    }
    initialize();

    function textbox_OnEnter(aEvent) {
        if (aEvent.keyCode == 13) {
            onSearch();
        } else if (aEvent.keyCode == 27) {
            onClear();
        }
    }

    function textSearch(aRequest) {
        var lLatitude = aRequest.location.lat();
        var lLongitude = aRequest.location.lng();

        GetPlacesRequest(lLatitude, lLongitude, '300', aRequest.query, function (aParams, aResults) {
            var results = aResults.results;

            results = results.map(function (result) {
                result.geometry.location = new google.maps.LatLng(result.geometry.location.lat, result.geometry.location.lng)
                result.geometry.viewport = new google.maps.LatLngBounds(result.geometry.location)

                return result;
            })

            onSearch_Complete(results, aResults.status)
        }, function (a, b) { console.log(a, b) })
    }

    this.dispose = function () {
        sumo.maps.Playback.prototype.dispose.call(this);
    };
};
sumo.maps.Locate.prototype = new sumo.Class();
sumo.maps.Locate.prototype.constructor = sumo.maps.Locate;
sumo.maps.Locate.prototype.baseClass = sumo.Class;